/* Version: 3.5.149 */
'use client';
import _extends from '@babel/runtime/helpers/extends';
import ContactUs from '../SideNav/shared/ContactUs.js';
import HeaderButton from '../SideNav/shared/HeaderButton.js';
import Lang from '../SideNav/shared/Lang.js';
import MenuItem from '../SideNav/shared/MenuItem.js';
import Search from '../SideNav/shared/Search.js';
import SignIn from '../SideNav/shared/SignIn.js';
import { HEADER_VARIANT, TAB_ALIGNMENT } from './constants.js';
import UtilityHeader$1 from './UtilityHeader.js';

var UtilityHeader = _extends(UtilityHeader$1, {
  VARIANT: HEADER_VARIANT,
  TAB_ALIGNMENT: TAB_ALIGNMENT,
  ContactUs: ContactUs,
  HeaderButton: HeaderButton,
  Lang: Lang,
  MenuItem: MenuItem,
  Search: Search,
  SignIn: SignIn
});

export { HEADER_VARIANT, TAB_ALIGNMENT, UtilityHeader as default };
